module.exports = __webpack_public_path__ + "static/media/logo-svs.d6461963.png";